module.exports = __webpack_public_path__ + "media/dashboard/assets/images/audit_log_icons/config-5e3c3529f5d91352023e40e4fa7d12b8.svg";